import { render, staticRenderFns } from "./RegionUsers.vue?vue&type=template&id=417792e2&"
import script from "./RegionUsers.vue?vue&type=script&lang=js&"
export * from "./RegionUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports